import * as PIXI from "pixi.js";
import { ColorMatrixFilter, Container, Sprite } from "pixi.js";
import { Sheets, Textures } from "./Textures";
import { ITransform } from "./ITransform";
import { Game } from "./Game";
import { DebugShade } from "./DebugShade";
import { BeeType } from "./BeeType";
import { Geom } from "./Geom";
import { Colors } from "./Colors";
import { Bees } from "./Bees";

export class Item implements ITransform {
	public readonly _container: PIXI.Container = new Container();
	public readonly sprite: Sprite;
	private readonly hitbox: DebugShade = new DebugShade()
	public size: number = 30;
	public destroyed: boolean = false;

	public constructor(parent: Container, public bee: BeeType) {
		this.sprite = new PIXI.Sprite(Bees[this.bee].texture());
		this.sprite.anchor.x = 0.5;
		this.sprite.anchor.y = 0.5;
		this.hitbox.size = this.size;
		parent.addChild(this._container);
		this._container.addChild(this.sprite);
		this._container.addChild(this.hitbox.graphics);
	}

	public destroy() {
		this.container.removeFromParent();
		this.destroyed = true;
	}

	public tick(deltaMS: number, game: Game) {
		this.hitbox.graphics.visible = game.showHitboxes;
		if (game.keys.e.held) {
			if (game.player.highlightedItem == this) {
				game.items.splice(game.items.indexOf(this), 1)
				game.player.addBee(this.bee)
				this.destroy()
			}
		}
	}

	public highlight(): void {
		let filter = new ColorMatrixFilter();
		filter.matrix = Colors.flashWhite(0.3);
		this.container.filters = [filter];
		this.container.scale = 1.3;
	}

	public unhighlight(): void {
		this.container.filters = [];
		this.container.scale = 1;
	}

	// region ITransform

	public get container(): Container {
		return this._container;
	}

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
